import { get, getOrThrow, set, watch } from 'quartz/globalState/api';
import { COPILOT_LAYOUT_TYPE, COPILOT_SIDEBAR_SIDE } from './globalState';
/**
 * Returns the name of the current package.
 *
 * @example
 * ```ts
 * import { getCopilotLayoutType } from 'quartz/framework/copilot/service';
 *
 * console.log(getCopilotLayoutType()); // 'sidebar'
 * ```
 */
export const getCopilotLayoutType = () => getOrThrow(COPILOT_LAYOUT_TYPE);
export const setCopilotLayoutType = type => set(COPILOT_LAYOUT_TYPE, type);
export const watchCopilotLayoutType = watch(COPILOT_LAYOUT_TYPE);
export const getCopilotSidebarSide = () => {
  var _get;
  return (_get = get(COPILOT_SIDEBAR_SIDE)) !== null && _get !== void 0 ? _get : 'right';
};
export const setCopilotSidebarSide = side => set(COPILOT_SIDEBAR_SIDE, side);
export const watchCopilotSidebarSide = watch(COPILOT_SIDEBAR_SIDE);